import { render, staticRenderFns } from "./ChanceList.vue?vue&type=template&id=db41103a"
import script from "./ChanceList.vue?vue&type=script&lang=js"
export * from "./ChanceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports